import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
} from 'recharts';

const MemberWebAnalyticsSparkline = ({ data, loading = false }) => {
    if (loading) {
        return (
            <div className="w-[200px] min-w-[200px] h-[72px] flex items-center justify-center text-xs text-gray-400">
                Loading...
            </div>
        );
    }

    if (!data?.series?.length) {
        return (
            <div className="w-[200px] min-w-[200px] h-[72px] flex items-center justify-center text-xs text-gray-400">
                No webID
            </div>
        );
    }

    const { series, totalViews = 0, totalVisitors = 0 } = data;

    return (
        <div className="w-[200px] min-w-[200px]">
            <ResponsiveContainer width="100%" height={56}>
                <LineChart data={series} margin={{ top: 4, right: 4, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
                    <XAxis dataKey="date" hide />
                    <YAxis hide domain={[0, 'auto']} />
                    <Tooltip
                        labelFormatter={(label) => label}
                        formatter={(value, name) => [
                            value,
                            name === 'views' ? 'Views' : 'Visitors',
                        ]}
                        contentStyle={{ fontSize: '12px' }}
                    />
                    <Line
                        type="monotone"
                        dataKey="views"
                        stroke="#9333ea"
                        strokeWidth={2}
                        dot={{ r: 2, fill: '#9333ea' }}
                        activeDot={{ r: 3 }}
                        isAnimationActive={false}
                    />
                    <Line
                        type="monotone"
                        dataKey="visitors"
                        stroke="#2563eb"
                        strokeWidth={2}
                        dot={{ r: 2, fill: '#2563eb' }}
                        activeDot={{ r: 3 }}
                        isAnimationActive={false}
                    />
                </LineChart>
            </ResponsiveContainer>
            <p className="text-[11px] text-gray-600 text-center leading-tight mt-0.5">
                {totalViews} view / {totalVisitors} visitors
            </p>
        </div>
    );
};

export default MemberWebAnalyticsSparkline;
